import {
	ChangeDetectionStrategy,
	Component,
	inject,
	input,
	output,
} from '@angular/core';
import {
	MatterPackageDocumentListComponent,
	DocumentToRenderPayload,
} from 'src/app/private/sale/documents-v2/matter-packages/matter-package/matter-package-document-list/matter-package-document-list.component';
import { MatterPackagesService } from 'src/app/shared/services/matter-packages/matter-packages.service';
import { ButtonComponent } from 'src/app/ui/button/button.component';

@Component({
	selector: 'app-e-signing-package-document-list-details',
	imports: [MatterPackageDocumentListComponent, ButtonComponent],
	templateUrl: './e-signing-package-document-list-details.component.html',
	changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ESigningPackageDocumentListDetailsComponent {
	private matterPackageService = inject(MatterPackagesService);
	public packageId_ = input<string>(null);
	public documentToRender_ = output<DocumentToRenderPayload>();
	public openDocumentDrawer() {
		this.matterPackageService.openDocumentsDrawer(this.packageId_());
	}
}
